import { useState } from 'react';

export default function DeliveryInfo() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [selectedPayment, setSelectedPayment] = useState<'invoice' | 'credit'>('invoice');

  const faqs = [
    {
      question: 'Q1. どんな文献を検索できますか？',
      answer: 'A. 医学・薬学分野を中心に、国内外の学術論文・レビュー・ガイドラインなど、幅広い文献を検索できます。英語文献も対応しております。'
    },
    {
      question: 'Q2. キーワードを決めるのが難しいのですが、相談できますか？',
      answer: 'A. はい、可能です。調査したいテーマをお知らせいただければ、最適なキーワード設定をご提案いたします。お気軽にご相談ください。'
    },
    {
      question: 'Q3. 文献リストはどのように届きますか？',
      answer: 'A. 検索結果は、メールアドレス宛にお送りします。\nメール内のURLをクリックすると、ブラウザ上で文献リストをご確認いただけます。\n必要な文献を選ぶだけで、そのまま複写のご依頼までスムーズに行えます。'
    },
    {
      question: 'Q5. 検索にはどれくらい時間がかかりますか？',
      answer: 'A. 通常は 当日〜翌営業日以内 にご提供しています。内容によっては追加のお時間をいただく場合がございます。'
    },
    {
      question: 'Q6. 料金体系はどのようになっていますか？',
      answer: 'A. 手数料＋実費(データベース利用料)＋精査料 で構成されています。実費は検索範囲や使用データベースにより異なります。'
    },
    {
      question: 'Q7. 事前に費用の見積もりはできますか？',
      answer: 'A. 通常は事前の費用案内は行っておりません。概算見積もりをご希望の場合は、別途お問い合わせください。'
    }
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">ご請求・お支払いについて</h2>
          <p className="text-lg text-gray-600">
            安心してご利用いただける明瞭な請求システム
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-10 border border-gray-100 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#eb4b3f] to-[#f0945b] rounded-full mb-8 shadow-lg mx-auto">
              <i className="ri-file-list-3-line text-4xl text-white"></i>
            </div>
            
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">お支払い方法</h3>
              <p className="text-base text-gray-600 mb-6">
                お客様のご都合に合わせて、お支払い方法をお選びいただけます。
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mb-6">
              <button
                onClick={() => setSelectedPayment('invoice')}
                className={`p-6 rounded-xl border-2 transition-all duration-300 cursor-pointer ${
                  selectedPayment === 'invoice'
                    ? 'border-[#eb4b3f] bg-[#eb4b3f]/5 shadow-lg'
                    : 'border-gray-200 bg-white hover:border-[#eb4b3f]/50'
                }`}
              >
                <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#eb4b3f] to-[#f0945b] rounded-full mb-4 mx-auto">
                  <i className="ri-file-text-line text-2xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">請求書払い</h4>
                <p className="text-sm text-gray-600">
                  後日、請求書を送付いたします。銀行振込にてお手続きをお願いいたします。
                </p>
                {selectedPayment === 'invoice' && (
                  <div className="mt-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#eb4b3f]"></i>
                  </div>
                )}
              </button>

              <button
                onClick={() => setSelectedPayment('credit')}
                className={`p-6 rounded-xl border-2 transition-all duration-300 cursor-pointer ${
                  selectedPayment === 'credit'
                    ? 'border-[#eb4b3f] bg-[#eb4b3f]/5 shadow-lg'
                    : 'border-gray-200 bg-white hover:border-[#eb4b3f]/50'
                }`}
              >
                <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#f0945b] to-[#eb4b3f] rounded-full mb-4 mx-auto">
                  <i className="ri-bank-card-line text-2xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">クレジット払い</h4>
                <p className="text-sm text-gray-600">
                  クレジットカードでのお支払いが可能です。各種カードに対応しております。
                </p>
                {selectedPayment === 'credit' && (
                  <div className="mt-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#eb4b3f]"></i>
                  </div>
                )}
              </button>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-5 border border-blue-200">
              <div className="flex items-start gap-3">
                <div className="flex items-center justify-center w-10 h-10 bg-blue-500 rounded-full flex-shrink-0">
                  <i className="ri-information-line text-xl text-white"></i>
                </div>
                <p className="text-sm text-gray-700">
                  ご注文時に、ご希望のお支払い方法をお選びください。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">よくあるご質問</h3>
            <p className="text-base text-gray-600">
              お客様からよくいただくご質問をまとめました
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-lg">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <h4 className="text-lg font-bold text-[#eb4b3f] pr-4">{faq.question}</h4>
                  <i className={`ri-arrow-down-s-line text-2xl text-[#eb4b3f] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
                </button>
                <div 
                  className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
                >
                  <div className="px-6 pb-5 pt-2">
                    <p className="text-base text-gray-700 leading-relaxed whitespace-pre-line">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
